<template>
  <div class="about-page" @scroll="scroll">
    <My-new-nav ref="header" :isHome='false'></My-new-nav>
    <div class="page-width about-cont">
      <div class="banner">
        <div class="view-width">
          <div class="banner-title">医疗行业革命者</div>
          <div class="banner-message">让医疗价值回归，让医疗更加温暖</div>
        </div>
      </div>
      <div class="view-bg-black">
        <div class="view-width view-pt-68">
          <ecn-title title="医智诺集团" message="搭建医疗新生态"></ecn-title>
          <div class="introduce">
            <div class="message">
              <div>医智诺集团是香港上市公司弘毅文化集团（HK00419，原华谊腾讯公司）旗下的医疗集团与控股子公司，作为一家致力于打造新医疗价值服务观的科技企业，医智诺一直将前沿的人工智能技术应用于医疗领域。</div>
              <div>医智诺集团战略定位为医疗产业数字化运营领跑者，聚焦于医疗产业，持续专注于医疗企业数字化转型服务，通过线上线下一体化联动为企业提供全发展周期商业化的数字化运营解决方案，以自主研发“苁蓉”数字化运营（DT）系统等多款产品并引入AI能力，赋能医生、患者、药房、药企等端口的有效串联及全场景私域化运营。</div>
              <div>医智诺集团始终围绕 TOB战略，致力于搭建全场景化的医疗服务平台，布局全产业医疗服务生态圈，总部位于苏州，研发中心位于古都西安，运营中心总部位于上海，目前已在全国建立3个事业部，业务覆盖 29 个省市自治区。作为医疗产业数字化运营领跑者，医智诺集团秉持与合作伙伴“共生、共渡、共赢”的理念，助力医疗企业数字化运营转型，赋能企业价值链全流程。</div>
            </div>
            <div class="video">
              <video ref="video" class="video-cont" :controls="videoControls" src="https://video.echartnow.com/sv/2633573c-183545037f3/2633573c-183545037f3.mp4">
                <p class="message">您的浏览器不支持播放视频</p>
              </video>
              <div class="video-play" v-show="!isPlay">
                <img src="../../assets/image/icon-play.png" alt="" @click="operateVideo">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="view-width view-pt-68">
          <ecn-title title="医智诺集团" message="搭建医疗新生态"></ecn-title>
          <div class="intro-list">
            <div class="intro-item">
              <img src="../../assets/image/aboutUs/icon-intro-1.png" alt="">
              <div class="intro-item-title">上市公司</div>
              <div class="intro-item-message">香港上市公司<br/>弘毅文化集团（HK00419）<br/>控股子公司</div>
            </div>
            <div class="intro-item">
              <img src="../../assets/image/aboutUs/icon-intro-2.png" alt="">
              <div class="intro-item-title">合法合规</div>
              <div class="intro-item-message">互联网诊疗资质<br/>医药／耗材全功能牌照<br/>CA认证在内的12+合法资质</div>
            </div>
            <div class="intro-item">
              <img src="../../assets/image/aboutUs/icon-intro-3.png" alt="">
              <div class="intro-item-title">全国布局</div>
              <div class="intro-item-message">已在全国建立3个事业部<br/> 业务覆盖29个省市自治区</div>
            </div>
            <div class="intro-item">
              <img src="../../assets/image/aboutUs/icon-intro-4.png" alt="">
              <div class="intro-item-title">技术创新</div>
              <div class="intro-item-message">21+软件著作权<br/>布局全产业医疗服务生态圈<br/>搭建全场景化医疗服务平台</div>
            </div>
          </div>
        </div>
      </div>
      <div class="view-bg-black">
        <div class="view-width view-pt-68">
          <ecn-title title="医智诺大数据" message="海量数据 无限可能"></ecn-title>
          <ecn-view-data></ecn-view-data>
        </div>
      </div>
      <div class="view-qualifications">
        <div class="view-width view-qualifications-bg">
          <ecn-title class="view-pt-68" title="合法合规资质" message="高新技术企业、互联网药品信息服务企业"></ecn-title>
          <div>
            <ecn-slide></ecn-slide>
          </div>
        </div>
      </div>
    </div>
    <My-new-footer></My-new-footer>
  </div>

</template>
<script>
import scrollHeaderStyle from "../newJoinus/utils";
export default {
  components: {

  },
  data() {
    return {
      videoControls: false,
      isPlay: false,
      pageType: "ecologicalSolutionPage",
    }
  },
  activated(){
      let context = this;
      scrollHeaderStyle(0, context, this.pageType )
  },
  mounted() {
    // 监听视频播放
    // this.$refs.video.addEventListener("play", () => {
    //   this.videoControls = true;
    //   this.isPlay = true;
    // });
    // // 监听视频暂停
    // this.$refs.video.addEventListener("pause", () => {
    //   this.videoControls = false;
    //   this.isPlay = false;
    // });
  },
  methods: {
    operateVideo() {
      this.$refs.video.play()
      this.videoControls = true;
      this.isPlay = true;
    },
    scroll(e){
      //滚动条滚动的事件
      let context = this;
      scrollHeaderStyle(e.srcElement.scrollTop, context, this.pageType )
    },
  }
}
</script>
<style lang="scss" scoped>
.about-page {
  font-size: 0;
  height: 100vh;
  overflow: auto;
  .about-cont {
    background-image: url('../../assets/image/aboutUs/bg-introduce.png');
    background-repeat: no-repeat;
    background-size: 100%;
    background-attachment: fixed;
  }
  .banner {
    height: 520px;
  }
  .banner-title {
    font-size: 60px;
    font-family: YouSheBiaoTiHei;
    color: #FFFFFF;
    line-height: 78px;
    letter-spacing: 6px;
    text-shadow: 0px 0px 6px rgba(6,58,148,0.5);
    padding-top: 204px;
  }
  .banner-message {
    font-size: 18px;
    font-family: SourceHanSansCN-Bold;
    color: #FFFFFF;
    line-height: 27px;
    letter-spacing: 9px;
    text-shadow: 0px 0px 6px rgba(6,58,148,0.5);
    margin-top: 19px;
  }
  .introduce {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items:flex-start;
    padding: 40px 0;
    padding-bottom: 100px;
    .message {
      width: 676px;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 30px;
      letter-spacing: 2px;
      div {
        margin-bottom: 30px;
      }
    }
    .video {
      width: 572px;
      height: 336px;
      margin-top: 8px;
      position: relative;
      .video-cont{
        width: 100%;
        height: 100%;
      }
      .video-play {
        width: 572px;
        height: 336px;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        img {
          width: 120px;
          height: 120px;
          cursor: pointer;
        }
      }
    }
  }
  .intro-list {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-start;
    padding: 52px 55px;
    padding-bottom: 94px;
    .intro-item {
      width: 270px;
      height: 336px;
      background: rgba(6, 45, 103, 0.7);
      box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.04);
      text-align: center;
      img {
        width: 140px;
        height: 108px;
        margin-top: 54px;
      }
      .intro-item-title {
        font-size: 22px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 30px;
        padding-top: 16px;
        padding-bottom: 8px;
      }
      .intro-item-message {
        font-size: 16px;
        font-weight: 400;
        color: #ACC7ED;
        line-height: 26px;
      }
    }
  }
  .view-qualifications {
    background-image: url('../../assets/image/aboutUs/certification-img.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .view-qualifications-bg {
    height: 900px;
    background-image: url('../../assets/image/aboutUs/certification-bg-img.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

}
</style>
